import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { parseSyllabusExcel,getSyllabusCountThunk } from "./redux/syllabusthunk";
import { fetchTeacherTimetable } from "./TimeTable/redux/myTimetableSlice";
import { useNavigate } from "react-router-dom";
import { getMasterDataByUserId } from "../../pages/masterData/redux/masterDataThunk";
import { fetchTeachers } from "../SchoolModule/teachers/redux/teacherSlice";
import userStore from "../../zustand/userStore";
import * as XLSX from "xlsx";
import {
  startTour,setStepIndex,stopTour} from "../../redux/globalJoyrideSlice";
import { adminUploadSyllabusFormTourSteps } from "../../tour/teacherPlanerTourSteps";

const AdminUploadSyllabus = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { teacherPeriods } = useSelector((state) => state.myTimetable);
  const { loading, error } = useSelector((state) => state.syllabus);
  const { teachers } = useSelector((state) => state.teachers);

  const [selectedTeacherId, setSelectedTeacherId] = useState("");
  const [formData, setFormData] = useState({
    selectedClass: "",
    selectedSubject: "",
    file: null,
  });

  const masterData = useSelector((state) => state.masterData);
  const schoolId = masterData?.school_id;
  const userData = userStore((state) => state.user);
// console.log(userData);
console.log(userData.roles);
  useEffect(() => {
    dispatch(getMasterDataByUserId(userData?.id));
  }, [dispatch]);

  useEffect(() => {
    if (schoolId) {
      dispatch(fetchTeachers());
    }
  }, [dispatch, schoolId]);

  useEffect(() => {
    if (selectedTeacherId) {
      dispatch(fetchTeacherTimetable(selectedTeacherId));
    }
  }, [dispatch, selectedTeacherId]);
  useEffect(() => {
    
  dispatch(
    startTour({
      activeTour: "admin-upload-syllabus",
      steps: adminUploadSyllabusFormTourSteps(),
    })
  );
}, [dispatch]);
const { stepIndex, run } = useSelector(
  (state) => state.globalJoyride
);
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "file" ? files[0] : value,
    }));
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (!formData.file) return alert("Please upload a file.");

  //   const fileType = formData.file.type;
  //   const isExcel =
  //     fileType ===
  //       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
  //     fileType === "application/vnd.ms-excel";

  //   if (!isExcel) return alert("Only Excel files are allowed.");

  //   await dispatch(parseSyllabusExcel(formData.file));
  //   navigate("/stage3", { state: formData });
  // };
const handleSubmit = async (e) => {
  e.preventDefault();
  dispatch(stopTour())

  if (!formData.file) {
    alert("Please upload a file.");
    return;
  }

  const fileType = formData.file.type;
  const isExcel =
    fileType === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
    fileType === "application/vnd.ms-excel";

  if (!isExcel) {
    alert("Only Excel files are allowed.");
    return;
  }

  try {
    // First parse and upload syllabus
    await dispatch(parseSyllabusExcel(formData.file)).unwrap();

    // Then fetch syllabus count
    const countResult = await dispatch(getSyllabusCountThunk()).unwrap();
    console.log("Syllabus count:", countResult.syllabus_count);

    // Check trial restriction
    if (userData.roles === "trial" && countResult.syllabus_count >= 5) {
      alert("You are in a trial period and can create only 5 syllabuses.");
      return; // stop here, don't navigate
    }

    // Otherwise move to next stage
    navigate("/stage3", { state: formData });
  } catch (err) {
    console.error("Error in handleSubmit:", err);
    alert("Something went wrong while processing syllabus.");
  }
};



  const handleDownload = () => {
    // Sample data for the sheet
    const sampleData = [
      { Term1: "Chapter 1", Term2: "Chapter 6" },
      { Term1: "Chapter 2", Term2: "Chapter 7" },
      { Term1: "Chapter 3", Term2: "Chapter 8" },
      { Term1: "Chapter 4", Term2: "Chapter 9" },
      { Term1: "Chapter 5", Term2: "Chapter 10" },
    ];

    // Create worksheet
    const worksheet = XLSX.utils.json_to_sheet(sampleData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sample");

    // Trigger download
    XLSX.writeFile(workbook, "Sample_Terms.xlsx");
  };

  // 🔹 Styles centralized here
  const styles = {
    container: {
      maxWidth: "650px",
      margin: "40px auto",
      padding: "30px",
      borderRadius: "12px",
      backgroundColor: "#ffffff",
      boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    },
    heading: {
      textAlign: "center",
      marginBottom: "25px",
      fontSize: "20px",
      fontWeight: "600",
      color: "#333",
    },
    formGroup: {
      marginBottom: "18px",
      display: "flex",
      flexDirection: "column",
    },
    label: {
      marginBottom: "6px",
      fontWeight: "500",
      fontSize: "14px",
      color: "#444",
    },
    input: {
      padding: "10px 12px",
      borderRadius: "6px",
      border: "1px solid #ccc",
      fontSize: "14px",
      outline: "none",
      transition: "border 0.2s ease-in-out",
    },
    select: {
      padding: "10px 12px",
      borderRadius: "6px",
      border: "1px solid #ccc",
      fontSize: "14px",
      outline: "none",
      backgroundColor: "#fff",
      cursor: "pointer",
    },
    button: {
      width: "100%",
      padding: "12px",
      backgroundColor: "#007bff",
      color: "#fff",
      border: "none",
      borderRadius: "6px",
      cursor: "pointer",
      fontSize: "15px",
      fontWeight: "600",
      transition: "background 0.3s ease-in-out",
    },
    error: {
      color: "red",
      marginTop: "10px",
      textAlign: "center",
      fontSize: "14px",
    },
  };

  return (
    <div style={styles.container}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "15px",
        }}
      >
        <h3 style={styles.heading}>📤 Upload Syllabus (Stage 1)</h3>
       <p
  data-tour="download-sample-excel"
  onClick={() => {
    handleDownload();
    dispatch(setStepIndex(4)); // → Upload file
  }}
  style={{
    color: "#007bff",
    textDecoration: "underline",
    cursor: "pointer",
    margin: 0,
  }}
>
  Download Sample Excel
</p>

      </div>

      <form onSubmit={handleSubmit}>
        {/* Teacher Selection */}
        <div style={styles.formGroup}>
          <label style={styles.label}>Select Teacher</label>
          <select
  data-tour="upload-select-teacher"
  style={styles.select}
  value={selectedTeacherId}
  onChange={(e) => {
    setSelectedTeacherId(e.target.value);
    dispatch(setStepIndex(1)); // → Class step
  }}
  required
>

            <option value="">-- Choose a teacher --</option>
            {Array.isArray(teachers) && teachers.length > 0 ? (
              teachers.map((teacher) => (
                <option key={teacher.teacher_id} value={teacher.teacher_id}>
                  {teacher.name}
                </option>
              ))
            ) : (
              <option disabled>No teachers found</option>
            )}
          </select>
        </div>

        {/* Class Selection */}
        <div style={styles.formGroup}>
          <label style={styles.label}>Class</label>
          <select
  data-tour="upload-select-class"
  name="selectedClass"
  value={formData.selectedClass}
  onChange={(e) => {
    handleChange(e);
    dispatch(setStepIndex(2)); // → Subject step
  }}
  required
  style={styles.select}
>

            <option value="">-- Select Class --</option>
            {teacherPeriods?.classes?.map((cls) => (
              <option key={cls.class_id} value={cls.class_id}>
                {cls.class_name}
              </option>
            ))}
          </select>
        </div>

        {/* Subject Selection */}
        <div style={styles.formGroup}>
          <label style={styles.label}>Subject</label>
          <select
  data-tour="upload-select-subject"
  name="selectedSubject"
  value={formData.selectedSubject}
  onChange={(e) => {
    handleChange(e);
    dispatch(setStepIndex(3)); // → Download step
  }}
  required
  style={styles.select}
>

            <option value="">-- Select Subject --</option>
            {teacherPeriods?.subjects?.map((subj) => (
              <option key={subj.subject_id} value={subj.subject_id}>
                {subj.subject_name}
              </option>
            ))}
          </select>
        </div>

        {/* File Upload */}
        <div style={styles.formGroup}>
          <label style={styles.label}>Upload Excel File</label>
          <input
  data-tour="upload-excel-file"
  type="file"
  name="file"
  accept=".xlsx,.xls"
  onChange={(e) => {
    handleChange(e);
    dispatch(setStepIndex(5)); // → Submit
  }}
  required
  style={styles.input}
/>

        </div>

        {/* Submit Button */}
        <div>
          <button
  data-tour="upload-submit-btn"
  type="submit"
  disabled={loading}
  style={styles.button}
>
  {loading ? "Uploading..." : "Upload & Continue"}
</button>

        </div>

        {/* Error */}
        {error && <p style={styles.error}>{error}</p>}
      </form>
    </div>
  );
};

export default AdminUploadSyllabus;
